// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","App-logo":"App_App-logo__25k4o","appHeader":"App_appHeader__28RXF","App-link":"App_App-link__3FsH9"};